export default __webpack_public_path__ + "7f345f72d1029b5ef0ad8856b2d01c9f.svg";